import transformer from '@/services/bodac/campagne/transformerCampagne';
import HTTP from '@/api/HTTP';

const URL_BASE = 'gescom/Campagne/';

export async function get(id) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: id } });
  return response;
}

export async function update(campagne) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', campagne);
  return response;
}

export async function create(campagne) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', campagne);
  return response;
}

export async function getAll(serverTabledata) {
  const inputServer = transformer(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function archiver(params) {
  const response = await HTTP.post(URL_BASE + 'ArchiverAsync', params);
  return response;
}

export async function createAll(campagnes) {
  const response = await HTTP.post(URL_BASE + 'CreateAllAsync', campagnes);
  return response;
}

export async function updateVisibiliteAll(params) {
  const response = await HTTP.put(URL_BASE + 'UpdateVisibiliteAllAsync', params);
  return response;
}
export async function deleteAsync(id) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id } });
  return response;
}
